// extracted by mini-css-extract-plugin
module.exports = {"nav":"_1jALEh","link":"_29dwIG"};